import React from 'react';

const Oregon = () => {
  return (
    <div>
      
    </div>
  );
}

export default Oregon;
